export enum BasedType {
	None = 0,
	User = 1,
	Project = 2
}
